export default {
  avatar: 'https://cdn.boxpressd.io/placeholder/default_avatar.png',
  user: 'https://cdn.boxpressd.io/placeholder/default_avatar.png',
  cigar: 'https://cdn.boxpressd.io/placeholder/no_cigar.png',
  band: 'https://cdn.boxpressd.io/placeholder/no-band.jpg',
  venue: 'https://cdn.boxpressd.io/placeholder/store_default.jpg',
  drink: 'https://cdn.boxpressd.io/placeholder/no_drink.png',
  yelpStars: 'https://cdn.boxpressd.io/placeholder/yelp_stars_default.png',
  covers: {
    profile: 'https://cdn.boxpressd.io/placeholder/profile_bg.jpg',
    venue: 'https://cdn.boxpressd.io/placeholder/venue_bg.jpg',
    humidor: 'https://cdn.boxpressd.io/placeholder/default_humidor.jpg',
  },
  location: {
    none: 'https://cdn.boxpressd.io/placeholder/s_logo.png',
    marker: 'https://cdn.boxpressd.io/assets/img/map-marker-42.png',
    current: 'https://cdn.boxpressd.io/assets/img/current_location.png',
  },
};
